<template>
    <div class="">
        <v-select v-model="sheet" ref="empSelect" label="EmployeeId" :filterable="false" @search="onSearch" @input="onChange" :options="options" :placeholder="`Search ${placeholder}`" :class="{'filter-select': forFilters, 'is-invalid': hasError}">
            <template slot="no-options">
                Type to search Safety Data Sheets...
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.data_sheet_name }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.data_sheet_name }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        props: {
            selectedValues: {
                type: Object,
                default: null
            },

            forFilters: {
                type: Boolean,
                default: false,
            },

            excludeId: {
                type: Number,
            },

            placeholder: {
                type: String,
                default: 'Safety Data Sheets by Name, Manufacturer, Supplier, or CAS#',
            },

            hasError: {
                type: Boolean,
                default: false,
            },

            filters: {
                type: Object,
                default: null
            },
        },

        data: function() {
            return {
                options: [],
                sheet: null,
            }
        },

        watch: {
            //Watcher for errors
            hasError(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            },

            selectedValues(newValue, oldValue){
                if(newValue != null && Object.keys(newValue).length > 0 && !this.sheet)
                {
                    this.options.push(newValue);
                    this.sheet = newValue;
                }
            }
        },

        methods: {
            //Search
            onSearch(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/safety-data-sheets/search', {term: searchTerm, excludeId: this.excludeId, filters: this.filters})
                    .then(res => {
                        //Set the data
                        this.options = res.data;

                        //Done loading
                        searchLoading(false);
                    });
            },

            setSelectedValues(sheet){
                //Set the value
                this.sheet = sheet;
            },

            //Emit the event
            onChange(sheet) {
                //Make sure we're not loading
                if (!this.loading)
                {
                    //Send it
                    this.$emit('vselected', sheet);
                }
            },

            clearInput(){
                //Set to null
                this.sheet = null;
                this.options = [];
                this.$refs.empSelect.clearSelection();
            }
        },

        mounted() {
            if(this.selectedValues != null && Object.keys(this.selectedValues).length > 0)
            {
                this.options.push(this.selectedValues);
                this.sheet = this.selectedValues;
            }
        }
    }
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }

    .vs__search::placeholder,
    .vs__dropdown-toggle,
    .vs__dropdown-menu {
      background: #dfe5fb;
      border: none;
      color: #394066;
      text-transform: lowercase;
      font-variant: small-caps;
    }

    .vs__clear,
    .vs__open-indicator {
      fill: #394066;
    }
</style>